import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=cf2253fa&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=cf2253fa&prod&scoped=true&lang=css"
import style1 from "./userInfo.vue?vue&type=style&index=1&id=cf2253fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2253fa",
  null
  
)

export default component.exports